import { render } from "./MyPropertyView.vue?vue&type=template&id=37b18998"
import script from "./MyPropertyView.vue?vue&type=script&lang=js"
export * from "./MyPropertyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__